import { SVGProps } from 'react';

const SvgRuns = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 11" {...props}>
        <path d="M6.744 2.36a.93.93 0 1 0 0-1.86.93.93 0 0 0 0 1.86ZM5.07 8.826l.465-2.047.977.93V10.5h.93V7.012l-.977-.93.28-1.396A3.394 3.394 0 0 0 9.301 5.85v-.93a2.285 2.285 0 0 1-2-1.117l-.465-.744a.935.935 0 0 0-.79-.465c-.14 0-.233.047-.373.047L3.256 3.663v2.186h.93V4.267l.837-.325-.744 3.767L2 7.244l-.186.93 3.256.652ZM.93 3.988a.465.465 0 1 1 0-.93h1.396v.93H.93Zm.465-1.86a.465.465 0 0 1 0-.93h2.326v.93H1.395Zm-.93 3.72a.465.465 0 0 1 0-.93h1.86v.93H.466Z" />
    </svg>
);
export default SvgRuns;
